var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMpFeatureIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h110v110H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.472 28.418c1.174 0 2.126-1.351 2.126-3.018 0-1.666-.952-3.017-2.126-3.017s-2.125 1.35-2.125 3.017c0 1.667.951 3.018 2.125 3.018ZM50.473 35.626V28.02M58.401 35.626V22.383M60.478 21.985v4.74a1.293 1.293 0 0 1-1.293 1.293h-1.567a1.293 1.293 0 0 1-1.293-1.293v-4.741M94.069 54.926v-3.322a14.657 14.657 0 0 0-29.315 0v3.322h.064M79.411 36.947v17.98",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.962 54.926s-1.45-14.968 7.45-17.979",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.86 54.926s1.45-14.968-7.449-17.979M94.292 81.277H64.531V92.24h29.761V81.277ZM79.411 81.277V52.915M68.463 54.926v26.35h22.164v-26.35M94.661 54.926h-4.033M68.463 54.926h22.164M68.463 54.926h-3.71M44.09 54.926v-3.322a14.657 14.657 0 0 0-29.315 0v3.322h.066M29.433 36.947v17.98",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.983 54.926s-1.45-14.968 7.45-17.979M36.883 54.926s1.45-14.968-7.45-17.979M44.314 81.277H14.552V92.24h29.762V81.277ZM29.433 81.277V52.915M18.484 54.926v26.35H40.65v-26.35M44.682 54.926h-4.033M18.484 54.926H40.65M18.485 54.926h-3.71",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.213 15H3v77.24h103.213V15Z",
    stroke: "#C3985A",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpFeatureIcon1);
export default __webpack_public_path__ + "static/media/mp-feature-icon-1.a5dd85682c230d87a5617df1301fe1ed.svg";
export { ForwardRef as ReactComponent };